module.exports = __webpack_public_path__ + "img/approve-list4.fe7e4e33.png";